// The stylesheets gate the green migration logo on this attribute, so production keeps the brand
// colour — see docs/next-muse-migration/temporary-deviations.md in the workspace umbrella.
const PRODUCTION_HOST = 'audio.com'

export const stampMigrationMarker = (): void => {
    if (typeof window === 'undefined' || window.location.host === PRODUCTION_HOST) {
        return
    }

    document.documentElement.dataset.migrationMarker = ''
}
